export const routes = {
  // Auth (tracking realm) — keys the auth pages/guards already reference.
  login: '/login',
  loginVerifyOtp: '/login/verify-otp',
  signup: '/signup',
  forgotPassword: '/forgot-password',
  forgotVerify: '/forgot-password/verify',
  forgotReset: '/forgot-password/reset',

  // Home redirects to /devices.
  home: '/',

  devices: '/devices',
  device: (id = ':id') => `/devices/${id}`,
  deviceSetup: (id = ':id') => `/devices/${id}/setup`,

  map: '/map',

  subscriptions: '/subscriptions',
  subscriptionCheckout: '/subscriptions/checkout',
  subscriptionPayment: '/subscriptions/payment',
  subscriptionPaymentApproved: '/subscriptions/payment/approved',
  subscriptionPaymentFailed: '/subscriptions/payment/failed',

  // Warranty claims listing + detail (stories 101871–101874). The :id route opens the
  // listing with that claim's detail drawer (also the notification deep-link target).
  warranty: '/warranty',
  warrantyClaim: (id = ':id') => `/warranty/${id}`,

  // Notification settings + center.
  notifications: '/notifications',

  profile: '/profile',

  notFound: '/404',
  serverError: '/500',
} as const;
